









import {Vue, Component, Model, Prop} from 'vue-property-decorator';
@Component
export default class CompRadioButton extends Vue {
  @Prop({required: true}) private radioOptions!: any;
  @Prop() private disabled?: boolean;

  @Model('change') readonly value!: number | string;
  get modelValue() {
    return this.value;
  }
  set modelValue(val) {
    this.$emit('change', val);
  }
  
  private handleClick(event) {
    this.$emit('handle-click', event);
  }
  
}
